import { Container, Row, Col, Button, Form } from "react-bootstrap";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import green_tick from "../../../images/green_tick.png";
import tick from "../../../images/tick.png";
import cross_icon from "../../../images/red_cross.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import countriesData from "../../../data/countries.json";
import { useState, useEffect } from "react";
import countriesStateData from "../../../data/states.json";
import { toHaveFormValues } from "@testing-library/jest-dom/matchers";
import BackButton from "../../Includes/BackButtonEntityAccount";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import renderField from "../../renderField";
import { connect } from "react-redux";
import {
  setEmail,
  setwizardPageNumber,
  setEmailVerify,
  setUserID,
  setEntityAccountUserDetails,
  setEntityAccountBusinessDetails,
  setBusinessAddressDetails,
  setwizardPageName,
} from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox, notifyError } from "MyComponents/Toaster";
import BusinessInformationForm from "./BusinessInformationForm";
import PhysicalBusinessAddressForm from "./PhysicalBusinessAddressForm";
import AccountUseForm from "./AccountUseForm";
import SuccessBusinessInfoForm from "./SuccessBusinessInfoForm";
import AuthorizedRepresentativeForm from "./AuthorizedRepresentativeForm";
import BeneficialOwnersForm from "./BeneficialOwnersForm";
import DirectorForm from "./DirectorForm";
import SuccessRelatedPartiesForm from "./SuccessRelatedPartiesForm";
import UploadDocumentForm from "./UploadDocumentForm";
import CertificationForm from "./CertificationForm";
import Spacer from "MyComponents/UI/Spacer";
import { useTranslation } from "react-i18next";

interface Props {}

const BusinessInformation: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { t } = useTranslation();
  const { handleSubmit } = props;
  const dispatch = useDispatch();
  const page = useSelector(
    (state: RootState) => state.entityAccount.wizardPageNumber
  );
  let wizardPageName = useSelector(
    (state: RootState) => state.entityAccount.pageName
  );

  const entityAccountBusinessDetails = useSelector(
    (state: RootState) => state.entityAccount.entityAccountBusinessDetails
  );

  const [PageName, setPageName] = useState(wizardPageName);

  const [BusinessInfo, setBusinessInfo] = useState(true);
  const [BusinessPhysicalAddress, setBusinessPhysicalAddress] = useState(false);
  const [AccountUse, setAccountUse] = useState(false);
  const [SuccessBusinessInfo, setSuccessBusinessInfo] = useState(false);
  const [SuccessRelatedParties, setRelatedParties] = useState(false);
  const [activeTab, setActiveTab] = useState("businessInfo");

  const [businessInfoVisible, setbusinessInfoVisible] = useState(true);
  const [relatedPartiesVisible, setRelatedPartiesVisible] = useState(false);
  const [documentsVisible, setDocumentsVisible] = useState(false);
  const [uploadDocument, setUploadDocument] = useState(false);
  const [activeTabDocument, setactiveTabDocument] = useState("uploaddoc");

  const [certificationVisible, setcertificationVisible] = useState(false);
  const [certification, setCertification] = useState(false);
  const [activeTabCertification, setactiveTabCertification] =
    useState("certification");

  const [AuthorizedRep, setAuthorizedRep] = useState(false);
  const [BeneficialOwners, setBeneficialOwners] = useState(false);
  const [Directors, setDirectors] = useState(false);
  const [activeTabRelatedParties, setActiveTabRelatedParties] =
    useState("authorizedRep");

  const navigate = useNavigate();

  const handleDocumentVisible = () => {
    setRelatedPartiesVisible(false);
    setbusinessInfoVisible(false);
    setDocumentsVisible(true);

    handleUploadDocument();
  };

  const handleCertificationVisible = () => {
    setRelatedPartiesVisible(false);
    setbusinessInfoVisible(false);
    setDocumentsVisible(false);
    setcertificationVisible(true);
    handlecertification();
  };

  const handlecertification = () => {
    setPageName("certification");
    localStorage.setItem('pageName', "certification");
    dispatch(setwizardPageName("certification"));
    wizardPageName = "certification";
    setAuthorizedRep(false);
    setBeneficialOwners(false);
    setDirectors(false);
    setBusinessPhysicalAddress(false);
    setBusinessInfo(false);
    setAccountUse(false);
    setUploadDocument(false);
    setCertification(true);
    setactiveTabCertification("certification");
  };

  const handleRelatedParties = () => {
    setRelatedPartiesVisible(true);
    setbusinessInfoVisible(false);
    setDocumentsVisible(false);
    setcertificationVisible(false);
    handleAuthorizedRep();
  };
  const handleBusinessInfoDiv = () => {
    setRelatedPartiesVisible(false);
    setbusinessInfoVisible(true);
    setDocumentsVisible(false);
    setcertificationVisible(false);
    handleBusinessInfo();
  };

  const handleBusinessInfo = () => {
    setPageName("businessInfo");
    localStorage.setItem('pageName', "businessInfo");
    dispatch(setwizardPageName("businessInfo"));
    wizardPageName = "businessInfo";
    setBusinessInfo(true);
    setBusinessPhysicalAddress(false);
    setAccountUse(false);
    setAuthorizedRep(false);
    setBeneficialOwners(false);
    setDirectors(false);
    setUploadDocument(false);
    setCertification(false);
    setActiveTab("businessInfo");
  };

  const handleBusinessPhysicalAddress = () => {
    setPageName("businessPhysicalAddress");
    localStorage.setItem('pageName', "businessPhysicalAddress");
    wizardPageName = "businessPhysicalAddress";
    dispatch(setwizardPageName("businessPhysicalAddress"));
    setBusinessPhysicalAddress(true);
    setBusinessInfo(false);
    setAccountUse(false);
    setAuthorizedRep(false);
    setBeneficialOwners(false);
    setDirectors(false);
    setUploadDocument(false);
    setCertification(false);
    setActiveTab("businessPhysicalAddress");
  };

  const handleAccountUse = () => {
    setPageName("accountUse");
    localStorage.setItem('pageName', "accountUse");
    wizardPageName = "accountUse";
    dispatch(setwizardPageName("accountUse"));
    setAccountUse(true);
    setBusinessPhysicalAddress(false);
    setBusinessInfo(false);
    setAuthorizedRep(false);
    setBeneficialOwners(false);
    setDirectors(false);
    setUploadDocument(false);
    setCertification(false);
    setActiveTab("accountUse");
  };

  const handleSuccessBusinessInfo = () => {
    setPageName("successBusinessInfo");
    localStorage.setItem('pageName', "successBusinessInfo");
    wizardPageName = "successBusinessInfo";
    dispatch(setwizardPageName("successBusinessInfo"));
    setSuccessBusinessInfo(true);
    setBusinessPhysicalAddress(false);
    setBusinessInfo(false);
    setAccountUse(false);
    setAuthorizedRep(false);
    setBeneficialOwners(false);
    setDirectors(false);
    setUploadDocument(false);
    setCertification(false);
  };

  const handleAuthorizedRep = () => {
    setPageName("authorizedRep");
    localStorage.setItem('pageName', "authorizedRep");
    wizardPageName = "authorizedRep";
    dispatch(setwizardPageName("authorizedRep"));
    setAuthorizedRep(true);
    setBeneficialOwners(false);
    setDirectors(false);
    setBusinessPhysicalAddress(false);
    setBusinessInfo(false);
    setAccountUse(false);
    setUploadDocument(false);
    setCertification(false);
    setActiveTabRelatedParties("authorizedRep");

  };

  const handleBeneficialOwners = () => {
    setPageName("beneficialOwners");
    localStorage.setItem('pageName', "beneficialOwners");
    wizardPageName = "beneficialOwners";
    dispatch(setwizardPageName("beneficialOwners"));
    setBeneficialOwners(true);
    setAuthorizedRep(false);
    setDirectors(false);
    setBusinessPhysicalAddress(false);
    setBusinessInfo(false);
    setAccountUse(false);
    setUploadDocument(false);
    setCertification(false);
    setActiveTabRelatedParties("beneficialOwners");
  };

  const handleDirectors = () => {
    setPageName("directors");
    localStorage.setItem('pageName', "directors");
    wizardPageName = "directors";
    dispatch(setwizardPageName("directors"));
    setDirectors(true);
    setBeneficialOwners(false);
    setAuthorizedRep(false);
    setBusinessPhysicalAddress(false);
    setBusinessInfo(false);
    setAccountUse(false);
    setUploadDocument(false);
    setCertification(false);
    setActiveTabRelatedParties("directors");
  };

  const handleSuccessRelatedParties = () => {
    setPageName("successRelatedParties");
    localStorage.setItem('pageName', "successRelatedParties");
    wizardPageName = "successRelatedParties";
    dispatch(setwizardPageName("successRelatedParties"));
    setRelatedParties(true);
    setSuccessBusinessInfo(false);
    setBusinessPhysicalAddress(false);
    setBusinessInfo(false);
    setAccountUse(false);
    setAuthorizedRep(false);
    setBeneficialOwners(false);
    setDirectors(false);
    setUploadDocument(false);
    setCertification(false);
    setActiveTabRelatedParties("successRelatedParties");
  };

  const handleUploadDocument = () => {
    setPageName("uploaddoc");
    wizardPageName = "uploaddoc";
    localStorage.setItem('pageName', "uploaddoc");
    dispatch(setwizardPageName("uploaddoc"));
    setUploadDocument(true);
    setAuthorizedRep(false);
    setBeneficialOwners(false);
    setDirectors(false);
    setBusinessPhysicalAddress(false);
    setBusinessInfo(false);
    setAccountUse(false);
    setactiveTabDocument("uploaddoc");
  };

  useEffect(() => {
    setPageName(wizardPageName);
    setActiveTab(wizardPageName);
    console.log("wizardPageName ", wizardPageName);
    console.log("activeTab ", activeTab);
  }, [wizardPageName, activeTab]);

  useEffect(() => {
    if (PageName == "businessInfo") {
      handleBusinessInfo();
    }
    if (PageName == "businessPhysicalAddress") {
      handleBusinessPhysicalAddress();
    }
    if (PageName == "accountUse") {
      handleAccountUse();
    }
    if (PageName == "successBusinessInfo") {
      handleSuccessBusinessInfo();
    }
    if (PageName == "authorizedRep") {
      handleRelatedParties();
    }
    if (PageName == "beneficialOwners") {
      handleBeneficialOwners();
    }
    if (PageName == "directors") {
      handleDirectors();
    }
    if (PageName == "successRelatedParties") {
      handleSuccessRelatedParties();
    }
    if (PageName == "uploaddoc") {
      handleDocumentVisible();
    }
    if (PageName == "certification") {
      handleCertificationVisible();
    }
    console.log("PageName ", PageName);
    console.log("activeTab ", activeTab);
  }, [PageName]);

  return (
    <>
      <Container fluid className="px-0 px-md-3">
        <Row className="g-0">
          <Col md={8}>
            <div className="mt-2">

              <Row
                className={PageName == "businessInfo" ? "" : " d-none"}
                id="business_info"
              >
                <>{handleBusinessInfo}</>

                <BusinessInformationForm />
              </Row>

              <Row
                className={
                  PageName == "businessPhysicalAddress" ? "" : "d-none"
                }
                id="physical_business_address"
              >
                <>
                  {handleBusinessPhysicalAddress}
                  <PhysicalBusinessAddressForm />
                </>
              </Row>

              <Row
                className={PageName == "accountUse" ? "" : " d-none"}
                id="account_use"
              >
                <AccountUseForm />
              </Row>

              <Row
                className={PageName == "successBusinessInfo" ? "" : " d-none"}
                id="success_business_info"
              >
                <SuccessBusinessInfoForm />
              </Row>

              <Row
                className={PageName == "authorizedRep" ? "" : "d-none"}
                id="authorized_representative"
              >
                <AuthorizedRepresentativeForm />
              </Row>

              <Row
                className={PageName == "beneficialOwners" ? "" : " d-none"}
                id="beneficialOwners"
              >
                <BeneficialOwnersForm />
              </Row>

              <Row
                className={PageName == "directors" ? "" : "d-none"}
                id="directors"
              >
                <DirectorForm />
              </Row>

              <Row
                className={PageName == "successRelatedParties" ? "" : " d-none"}
                id="success_related_parties"
              >
                <SuccessRelatedPartiesForm />
              </Row>

              <Row
                className={PageName == "uploaddoc" ? "" : "d-none"}
                id="upload_doc"
              >
                <UploadDocumentForm />
              </Row>

              <Row
                className={PageName == "certification" ? "" : "d-none"}
                id="certification_doc"
              >
                <CertificationForm />
              </Row>
            </div>
          </Col>
          <Col md={4} className="d-none d-md-block">
            <br />
            <br />
            <br />
            <br />
            <br />

            <Row>
              <Col md={12} className=" p-4 mt-2 rounded-4 mx-2">
                <div
                  className={
                    businessInfoVisible ? "row rounded-2" : "row rounded-2"
                  }
                  style={{ background: "#E6F9F2" }}
                >
                  <p
                    className={
                      businessInfoVisible
                        ? "small text-black my-2  text-uppercase fw-bold"
                        : "small text-secondary text-uppercase my-2 "
                    }
                    onClick={handleBusinessInfoDiv}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_business_info')}
                  </p>
                </div>
                <div
                  className={
                    relatedPartiesVisible ? "row rounded-2 mt-2" : "d-none"
                  }
                  style={{ background: "#E6F9F2" }}
                >
                  <p
                    className={
                      relatedPartiesVisible
                        ? "small text-black  my-2  text-uppercase fw-bold"
                        : "small text-secondary text-uppercase my-2 "
                    }
                    onClick={handleRelatedParties}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_related_parties')}
                  </p>
                </div>

                <div
                  className={documentsVisible ? "row rounded-2 mt-2" : "d-none"}
                  style={{ background: "#E6F9F2" }}
                >
                  <p
                    className={
                      documentsVisible
                        ? "small text-black  my-2 text-uppercase  fw-bold"
                        : "small text-secondary text-uppercase  my-2 "
                    }
                    onClick={handleDocumentVisible}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_documents')}
                  </p>
                </div>
                <div
                  className={
                    certificationVisible ? "row rounded-2 mt-2" : "d-none"
                  }
                  style={{ background: "#E6F9F2" }}
                >
                  <p
                    className={
                      certificationVisible
                        ? "small text-black  my-2 text-uppercase  fw-bold"
                        : "small text-secondary text-uppercase  my-2 "
                    }
                    onClick={handleCertificationVisible}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_certifications')}
                  </p>
                </div>

                <div
                  className={
                    businessInfoVisible
                      ? "row  p-2 mb-3 mt-2 rounded-4"
                      : "row d-none"
                  }
                  id="buss_info_div"
                >
                  <p
                    className={`small ${
                      activeTab === "businessInfo"
                        ? "text-primary"
                        : "text-secondary"
                    } fw-bold`}
                    onClick={handleBusinessInfo}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_business_info')}
                  </p>
                  <p
                    className={`small ${
                      activeTab === "businessPhysicalAddress"
                        ? "text-primary"
                        : "text-secondary"
                    }  fw-bold`}
                    onClick={handleBusinessPhysicalAddress}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_physical_address')}
                  </p>
                  <p
                    className={`small ${
                      activeTab === "accountUse"
                        ? "text-primary"
                        : " text-secondary"
                    } fw-bold my-0`}
                    onClick={handleAccountUse}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_account_use')}
                  </p>
                </div>
                <div
                  className={
                    relatedPartiesVisible
                      ? "row  p-2 mb-3 mt-2 rounded-4"
                      : "row d-none"
                  }
                  id="related_parties_div"
                >
                  <p
                    className={`small ${
                      activeTabRelatedParties === "authorizedRep"
                        ? "text-primary"
                        : "text-secondary"
                    } fw-bold`}
                    onClick={handleAuthorizedRep}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_auth_rep')}
                  </p>
                  <p
                    className={`small ${
                      activeTabRelatedParties === "beneficialOwners"
                        ? "text-primary"
                        : "text-secondary"
                    }  fw-bold`}
                    onClick={handleBeneficialOwners}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_beneficial_owners')}
                  </p>
                  <p
                    className={`small ${
                      activeTabRelatedParties === "directors"
                        ? "text-primary"
                        : " text-secondary"
                    } fw-bold my-0`}
                    onClick={handleDirectors}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_directors')}
                  </p>
                </div>
                <div
                  className={
                    documentsVisible
                      ? "row  p-2 mb-3 mt-2 rounded-4"
                      : "row d-none"
                  }
                  id="documents_div"
                >
                  <p
                    className={`small ${
                      activeTabDocument === "uploaddoc"
                        ? "text-primary"
                        : "text-secondary"
                    } fw-bold m-0`}
                    onClick={handleUploadDocument}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_upload_docs')}
                  </p>
                </div>
                <Row
                  className={
                    certificationVisible
                      ? " p-2 mb-3 mt-2 rounded-4"
                      : "d-none"
                  }
                  id="certifiaction_div"
                >
                  <p
                    className={`small ${
                      activeTabCertification === "certification"
                        ? "text-primary"
                        : "text-secondary"
                    } fw-bold m-0 letter-spacing-fix`}
                    onClick={handlecertification}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_certification')}
                  </p>
                </Row>

                <Row>
                  <p
                    className={
                      relatedPartiesVisible
                        ? "d-none"
                        : "text-uppercase small text-secondary fw-bold"
                    }
                    onClick={handleRelatedParties}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_related_parties')}
                  </p>
                  <p
                    className={
                      documentsVisible
                        ? "d-none"
                        : "text-uppercase small text-secondary fw-bold"
                    }
                    onClick={handleDocumentVisible}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_documents')}
                  </p>
                  <p
                    className={
                      certificationVisible
                        ? "d-none"
                        : "text-uppercase small text-secondary fw-bold letter-spacing-fix"
                    }
                    onClick={handleCertificationVisible}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('kyc.entity_nav_certification')}
                  </p>
                </Row>
              </Col>
              <Col md={4}></Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: "entityWizard",
  enableReinitialize: true,
})(BusinessInformation);

export default connect(null)(form);
